<template>
<div class="face-failure-content">
  <div class="left">
    <face-log-photo :faceLogId="faceLogId" />
    <face-status-error errors-only :face-status="faceStatus" style="margin-top: .5rem" />
  </div>
  <div class="right">

    <slot name="employeeQuestion" />

    <div class="face-decisions">
      <Button severity="success"
        :disabled="approveDisabled"
        size="small"
        @click="approve"><font-awesome-icon icon="check" class="icon" /> {{ approveText }}</Button>
      <Button severity="danger"
        :disabled="rejectDisabled"
        size="small"
        @click="reject"><font-awesome-icon icon="ban" class="icon" /> {{ rejectText }}</Button>
    </div>

    <span class="log-detail">
      {{ punchType?.toUpperCase() }}
      @ {{ clockName }}<br/>
      on {{ localDate }}
    </span>

    <multiple-face-matches
      :matches="multipleMatches"
      style="margin-top: .5rem"
    />
  </div>
</div>
</template>
<script>
import moment from 'moment-timezone'
import FaceLogPhoto from '@/modules/attendance/clocklogs/FaceLogPhoto.vue'
import FaceStatusError from '@/modules/users/FaceStatusError.vue'
import MultipleFaceMatches from '@/modules/users/MultipleFaceMatches.vue'
import Button from 'primevue/button'

export default {
  name: 'FaceFailureContent',
  components: {
    FaceLogPhoto,
    FaceStatusError,
    MultipleFaceMatches,
    Button
  },
  inheritAttrs: false,
  data () {
    return {
      employee: null,
      loading: false,
      loaded: false,
      options: []
    }
  },
  props: {
    date: String,
    timezone: String,
    faceLogId: Number,
    faceStatus: String,
    multipleMatches: Array,
    punchType: String,
    clockName: String,
    approveText: {
      type: String,
      default: 'Approve'
    },
    rejectText: {
      type: String,
      default: 'Reject'
    },
    approveDisabled: {
      type: Boolean,
      default: false
    },
    rejectDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localDate () {
      return moment(this.date).tz(this.timezone).format('llll')
    }
  },
  methods: {
    approve () {
      this.$emit('approve', this.employee)
    },
    reject () {
      this.$emit('reject')
    }
  }
}
</script>
<style scoped>
.face-failure-content {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;

  > * {
    margin: 5px;
  }

  .left {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .right {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;

    .face-decisions {
      margin-top: 0.25rem;
      display: flex;
      gap: 0.35rem;

      .icon {
        margin-right: 4px;
      }
    }

    .log-detail {
      font-size: 0.75rem;
      color: var(--color-slate-400);
      line-height: 1.4;
      margin-top: 0.15rem;
    }
  }
}
</style>

